<template>
  <component
    :is="wrapper"
    :target="target"
    :offset-top="offsetTop"
    :offset-bottom="offsetBottom"
  >
    <div
      class="ten-anchor-wrapper"
      :style="{ maxHeight: offsetTop ? `calc(100vh - ${offsetTop}px)` : '100vh' }"
    >
      <div
        class="ten-anchor"
      >
        <div class="ten-anchor__prefix">
          <span
            ref="dot"
            :class="['ten-anchor__prefix-dot', { visible: activeLink }]"
          />
        </div>
        <slot />
      </div>
    </div>
  </component>
</template>

<script>
import TenAffix from '../affix';
import { sharpMatcherRegx, getOffsetTop, scrollTo } from './util';

const name = 'ten-anchor';
const CustomWrapper = { render(h) {
  return h('div', this.$slots.default);
} };

export default {
  name,
  provide() {
    return {
      anchor: this,
    };
  },
  components: {
    CustomWrapper,
    TenAffix,
  },
  props: {
    /**
     * 开启固定模式
     */
    affix: {
      type: Boolean,
      default: true,
    },
    /**
     * 锚点区域边界
     */
    bounds: {
      type: Number,
      default: 5,
    },
    /**
     * 是否显示小圆点
     */
    showDot: {
      type: Boolean,
      default: true,
    },
    /**
     * 监听滚动的元素(默认为window)，传入选择器字符串如'#parent'
     */
    target: String,
    /**
     * 距离窗口顶部达到指定偏移量后触发
     */
    offsetTop: {
      type: Number,
      default: 0,
    },
    /**
     * 距离窗口底部达到指定偏移量后触发
     */
    offsetBottom: {
      type: Number,
    },
  },
  data() {
    this.links = [];
    this.container = null;
    return {
      activeLink: null,
    };
  },
  computed: {
    wrapper() {
      return this.affix ? 'ten-affix' : 'custom-wrapper';
    },
  },
  mounted() {
    this.$on('link:click', this.onLinkClick);
    this.$nextTick(() => {
      this.container = document.querySelector(this.target) || window;
      this.container.addEventListener('scroll', this.handleScroll);
      this.handleScroll();
    });
  },
  beforeDestroy() {
    this.container.addEventListener('scroll', this.handleScroll);
  },
  updated() {
    this.$nextTick(this.updateDot);
  },
  methods: {
    appendLink(link) {
      if (!this.links.includes(link)) {
        this.links.push(link);
      }
    },
    removeLink(link) {
      const index = this.links.indexOf(link);
      if (index !== -1) {
        this.links.splice(index, 1);
      }
    },
    onLinkClick(e, link) {
      /**
       * 锚点点击时触发
       *
       * @event click
       * @param {Object} LinkProps
       */
      this.$emit('click', e, link.$props);
    },
    handleScroll() {
      if (this.animating) {
        return;
      }
      const { offsetTop, bounds } = this;
      this.activeLink = this.getCurrentAnchor(offsetTop, bounds);
    },
    scrollTo(link) {
      const { offsetTop, container } = this;
      this.animating = true;
      this.activeLink = link;
      scrollTo(link, offsetTop, container, () => {
        this.animating = false;
      });
    },
    getCurrentAnchor(offsetTop = 0, bounds = 5) {
      const activeLink = '';
      if (typeof document === 'undefined') {
        return activeLink;
      }

      const linkSections = [];
      this.links.forEach((link) => {
        const sharpLinkMatch = sharpMatcherRegx.exec(link.toString());
        if (!sharpLinkMatch) {
          return;
        }
        const target = document.getElementById(sharpLinkMatch[1]);
        if (target) {
          const top = getOffsetTop(target, this.container);
          if (top < offsetTop + bounds) {
            linkSections.push({
              link,
              top,
            });
          }
        }
      });

      if (linkSections.length) {
        const maxSection = linkSections.reduce((prev, curr) => (curr.top > prev.top ? curr : prev)); // eslint-disable-line
        return maxSection.link;
      }
      return '';
    },
    updateDot() {
      if (typeof document === 'undefined') {
        return;
      }
      const [linkNode] = this.$el.getElementsByClassName(`${name}-link-title--active`);
      if (linkNode) {
        this.$refs.dot.style.top = `${linkNode.offsetTop + (linkNode.clientHeight / 2) - 4.5}px`;
      }
    },
  },
};
</script>
